
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pemetaan-kompetensi/data-tidak-sesuai",
      function () {
        return require("private-next-pages/pemetaan-kompetensi/data-tidak-sesuai.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pemetaan-kompetensi/data-tidak-sesuai"])
      });
    }
  